module.exports = __webpack_public_path__ + "3edb628fc5010edfa45297912130c848.woff";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/TiemposTextWeb-Regular.woff
// module id = 1103
// module chunks = 0